import { render } from "./DataAvailability.vue?vue&type=template&id=6efeaf92&scoped=true"
import script from "./DataAvailability.vue?vue&type=script&lang=js"
export * from "./DataAvailability.vue?vue&type=script&lang=js"

import "./DataAvailability.vue?vue&type=style&index=0&id=6efeaf92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efeaf92"]])

export default __exports__